// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__logo":"Footer_footer__logo__BWqr7","footer__menu":"Footer_footer__menu__JwB1x"};